export enum PermissionEnum {
  VIEW_SALES = 'view_sales',
  MANAGE_ITEMS = 'manage_items',
  VIEW_COST_OF_ITEMS = 'view_cost_of_items',
  MANAGE_FEATURE_SETTINGS = 'manage_feature_settings',
  MANAGE_BILLING = 'manage_billing',
  MANAGE_PAYMENT_TYPES = 'manage_payment_types',
  MANAGE_TAXES = 'manage_taxes',
  MANAGE_STORES = 'manage_stores',
}
